// Route module loaders for prefetching
const routeModules: Record<string, () => Promise<unknown>> = {
  '/': () => import('@/pages/Index'),
  '/dashboard': () => import('@/pages/DashboardPage'),
  '/settings': () => import('@/pages/SettingsPage'),
  '/onboarding': () => import('@/pages/GenniPage'),
  '/new-reading': () => import('@/pages/NewReadingPage'),
  '/login': () => import('@/pages/LoginPage'),
  '/signup': () => import('@/pages/SignupPage'),
  '/settings/password': () => import('@/pages/ChangePasswordPage'),
  '/settings/email': () => import('@/pages/ChangeEmailPage'),
};

// Prefetch a route's module on hover
export const prefetchRoute = (path: string) => {
  // Normalize path (remove query params and hash)
  const normalizedPath = path.split('?')[0].split('#')[0];
  const loader = routeModules[normalizedPath];
  
  if (loader) {
    // Trigger the import (browser will cache it)
    loader().catch(() => {
      // Silently fail - prefetching is optional optimization
    });
  }
};

// Prefetch common routes in background after app loads
export const prefetchCommonRoutes = () => {
  const commonRoutes = ['/dashboard', '/settings', '/onboarding'];
  
  // Stagger prefetches to avoid blocking
  commonRoutes.forEach((route, index) => {
    setTimeout(() => {
      prefetchRoute(route);
    }, 1000 + (index * 500)); // Start after 1s, 500ms apart
  });
};
